import React from "react";
import PrintablePage from "components/print_story/printable_page";
import {Button} from "components/common_style/button";
import {toJpeg, toSvg} from 'html-to-image';
import jsPDF from 'jspdf';

class PrintStory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            progress: 0
        };
        this.storyData = this.props.storyDoc.data();
        this.pages = this.storyData.pages;
        this.nToLoad = this.pages.length;
        this.pageRefs = {};
        for (let i = 0; i < this.nToLoad; i++) {
            this.pageRefs[this.pages[i].id] = React.createRef();
        }
        this.pageWidgets = this.pages.map((p, i) => <PrintablePage
            id={p.id}
            page={p}
            storyDoc={this.props.storyDoc}
            pageN={i}
            ref={this.pageRefs[p.id]}
            handleLoaded={() => this._loaded()}
        />);
    }


    render() {
        return <div>
            {this.props.generatingView(this.state.progress, this.storyData.pages.length)}
            <div style={{position: 'absolute', left: '100vw'}}>
                {this.pageWidgets}
            </div>
        </div>;
    }

    _loaded() {
        this.nToLoad--;
        if (this.nToLoad !== 0) return;
        this._makePdf();
    }

    _getImg(dataUrl) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            console.log("ok");
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = dataUrl;
        });
    }

    async _makePdf() {
        let pw = 1920 * 2;
        let ph = 1080 * 2;
        let doc = new jsPDF('l', 'pt', [pw, ph]);
        for (let i = 0; i < this.pages.length; i++) {
            let pg = document.getElementById(this.pages[i].id);
            let impg = await toJpeg(pg, {quality: 0.95});
            let img = await this._getImg(impg);
            doc.addImage(img, 'JPEG', 0, 0, pw, ph);
            doc.addPage();
            this.setState({
                progress: this.state.progress + 1
            })
        }
        doc.save(this.storyData.title + '.pdf');
        this.setState({
            done: true
        });
        if (!!this.props.onDone) this.props.onDone();
    }
}

export default PrintStory;
